import { OrganizationDto } from './organization-dto';
export class ImportCandidateDto {
    id = -1;
    exportingOrganization!: OrganizationDto;
    exportTimestamp!: Date;
    isImported: boolean = false;
    isTrackable: boolean = false;
    hasNotification: boolean = false;
}
